import React from 'react';
import { Helmet } from 'react-helmet-async';

export const SEO = ({
  title = "Symbionic – Making insurance simple and reliable for everyone in Australia",
  description = "Symbionic are on a mission to help Australian policyholders unravel the complexities associated with insurance, using AI-Powered smart apps that help to improve understanding and remove potential pain points.",
  canonical = "https://symbionic.com.au/",
  ogImage = "https://symbionic.com.au/symbionic-logo.png",
  ogType = "website"
}) => {
  const fullTitle = title.includes('Symbionic') ? title : `${title} | Symbionic`;
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonical} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonical} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEO;
